module.exports = __webpack_public_path__ + "img/team3.63580210.jpg";